/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { icons } from "src/environments/config";
import { RegisterStoreComponent } from "../register-store.component";
import { DialogService } from "src/app/services/dialog-service/dialog.service";
import { setActualDimensions } from "../../../liveshop/utils/helpers";
import { RegisterStoreApiService } from "src/app/services/register-store/register-store-api.service";
import { FormBuilder, Validators } from "@angular/forms";
import { RegisterStoreDataService } from "src/app/services/register-store/register-store-data.service";
import { ToastrService } from "ngx-toastr";
import { WhiteshopLoginComponent } from "../../whiteshop-login/whiteshop-login.component";
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { Router } from "@angular/router";
import { RegexService } from "src/app/services/shared/regex/regex.service";

@Component({
  selector: "app-verify-otp-store",
  templateUrl: "./verify-otp-store.component.html",
  styleUrls: ["./verify-otp-store.component.scss"],
})
export class VerifyOtpStoreComponent implements OnInit {
  otp;
  windowHeight: number;
  windowWidth: number;
  eachRegex = /^[0-9]{1}$/;
  whiteShopIcon = icons.whiteShopIcon.icon;
  @ViewChild("box1", { static: false }) box1: ElementRef;
  @ViewChild("box2", { static: false }) box2: ElementRef;
  @ViewChild("box3", { static: false }) box3: ElementRef;
  @ViewChild("box4", { static: false }) box4: ElementRef;
  @ViewChild("box5", { static: false }) box5: ElementRef;
  @ViewChild("box6", { static: false }) box6: ElementRef;
  resendCode = "";

  constructor(
    public formBuilder: FormBuilder,
    public toastrService: ToastrService,
    public registerStoreDataService: RegisterStoreDataService,
    // public registerStoreDialog: MatDialogRef<RegisterStoreComponent>,
    public whiteshopLoginDialog: MatDialogRef<WhiteshopLoginComponent>,
    public verifyOtpDialog: MatDialogRef<VerifyOtpStoreComponent>,
    public registerDialog: MatDialogRef<RegisterStoreComponent>,
    @Inject(MAT_DIALOG_DATA) public userData: any,
    public router: Router,
    public localStorageService: LocalStorageService,
    public registerStoreApiService: RegisterStoreApiService,
    public dialogService: DialogService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    public regexService: RegexService
  ) {}

  public otpForm = this.formBuilder.group({
    box1: [null, [Validators.required, Validators.pattern(this.eachRegex)]],
    box2: [null, [Validators.required, Validators.pattern(this.eachRegex)]],
    box3: [null, [Validators.required, Validators.pattern(this.eachRegex)]],
    box4: [null, [Validators.required, Validators.pattern(this.eachRegex)]],
    box5: [null, [Validators.required, Validators.pattern(this.eachRegex)]],
    box6: [null, [Validators.required, Validators.pattern(this.eachRegex)]],
  });

  ngOnInit(): void {
    this.resendCode = "";
    this.iconRegistry.addSvgIcon(
      "arrow_back",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/arrowBackBlack.svg"
      )
    );
    this.localStorageService.isLogoUpdated.subscribe((data) => {
      if (data && data.length) {
        this.whiteShopIcon = data[0];
      }
    });
    window.addEventListener("resize", () => {
      this.setDimensions();
    });
    this.setDimensions();
    // console.log(this.userData.data.otp);
  }

  onKeyUpFunction(index) {
    const name = "box" + index;
    if (this.otpForm.controls[name].valid && index <= 6) {
      this.focus(index + 1);
    } else {
      this.otpForm.controls[name].reset();
    }
  }
  focus(index) {
    switch (index) {
      case 1:
        this.box1.nativeElement.focus();
        this.otpForm.controls.box1.reset();
        break;
      case 2:
        this.box1.nativeElement.blur();
        this.box2.nativeElement.focus();
        this.otpForm.controls.box2.reset();
        break;
      case 3:
        this.box2.nativeElement.blur();
        this.box3.nativeElement.focus();
        this.otpForm.controls.box3.reset();
        break;
      case 4:
        this.box3.nativeElement.blur();
        this.box4.nativeElement.focus();
        this.otpForm.controls.box4.reset();
        break;
      case 5:
        this.box4.nativeElement.blur();
        this.box5.nativeElement.focus();
        this.otpForm.controls.box5.reset();
        break;
      case 6:
        this.box5.nativeElement.blur();
        this.box6.nativeElement.focus();
        this.otpForm.controls.box6.reset();
        break;
      case 7:
        this.box6.nativeElement.blur();
      default:
        break;
    }
  }

  onFocusEvent(index) {
    for (let item = 1; item < index; item++) {
      const name = "box" + item;
      if (!this.otpForm.controls[name].valid) {
        this.focus(item);
        break;
      }
    }
    const name2 = "box" + index;
    this.otpForm.controls[name2].reset();
  }
  onPasteOtp($event: ClipboardEvent) {
    let pastedText = $event.clipboardData.getData("text");
    pastedText = pastedText.replace(/ /g, "");
    const otpRegex = new RegExp(/^[0-9]{6}$/);
    $event.preventDefault();
    $event.stopPropagation();
    if (pastedText.length !== 6 || !otpRegex.test(pastedText)) {
      this.toastrService.error("The OTP is not in correct format", null, {
        timeOut: 2000,
      });
      return;
    }
    for (let a = 0; a < 6; a++) {
      const name = "box" + (a + 1);
      this.otpForm.controls[name].reset();
      this.otpForm.controls[name].patchValue(pastedText[a]);
    }
    this.box1.nativeElement.blur();
    this.box2.nativeElement.blur();
    this.box3.nativeElement.blur();
    this.box4.nativeElement.blur();
    this.box5.nativeElement.blur();
    this.box6.nativeElement.blur();
  }
  setDimensions() {
    const dimensions = setActualDimensions();
    this.windowHeight = dimensions.windowHeight;
    this.windowWidth = dimensions.windowWidth;
  }

  isMobileDevice() {
    return this.windowWidth <= 6;
  }

  isTabDevice() {
    return this.windowWidth > 6 && this.windowWidth <= 9;
  }

  verifyOtp() {
    const otp =
      this.otpForm.controls.box1.value.toString() +
      this.otpForm.controls.box2.value.toString() +
      this.otpForm.controls.box3.value.toString() +
      this.otpForm.controls.box4.value.toString() +
      this.otpForm.controls.box5.value.toString() +
      this.otpForm.controls.box6.value.toString();
    this.registerStoreApiService
      .postRegisterPreSignUpOtp({
        isverifyotp: true,
        otp,
        username: this.userData.data.user.username,
      })
      .subscribe(
        (res) => {
          // this.dialogService.openMatDialog(CreateCompanyComponent, res, true);
          this.registerStoreDataService.companyRegisterData = res;
          this.router.navigateByUrl("my-company/createCompany").then(() => {
            this.verifyOtpDialog.close();
          });
        },
        (err) => {
          this.toastrService.error(err.error.message, null, { timeOut: 2000 });
        }
      );
  }

  loginRegisteredUser() {
    this.registerStoreApiService
      .storeLogin({
        username: this.userData.data.user.username,
        password: this.registerStoreDataService.registerStorePassword,
      })
      .subscribe(
        (res) => {
          if (res) {
            this.localStorageService.setUserData(res);
            this.router.navigateByUrl("/appointments");
            this.toastrService.success("Registration successful", null, {
              timeOut: 2000,
            });
          }
        },
        (err) => {
          this.toastrService.error(err.error.message, null, { timeOut: 2000 });
        }
      );
  }

  backToHome() {
    this.verifyOtpDialog.close();
  }

  resendOtp() {
    const resendOtpObject = this.getOtpRequestObject();
    this.registerStoreApiService
      .postRegisterPreSignUpOtp(resendOtpObject)
      .subscribe(
        (res) => {
          this.otpForm.reset();
          this.resendCode = " again ";
          this.toastrService.success("Resent OTP", null, { timeOut: 2000 });
        },
        (err) => {
          this.toastrService.error(err.error.message, null, { timeOut: 2000 });
        }
      );
  }

  getOtpRequestObject() {
    return {
      issendotp: true,
      companyName: "ShopConnect",
      username: this.userData.data.user.username,
      password: this.registerStoreDataService.registerStorePassword,
    };
  }

  submit() {
    if (!this.otpForm.invalid) {
      this.verifyOtp();
    }
  }
}
